import './styles.css'
import { useState, memo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { CheckOutlined, ShoppingCartOutlined, GiftFilled } from '@ant-design/icons';
import {ReactComponent as Star} from "../../icons/star.svg";
import {ReactComponent as Heart} from "../../icons/heart-icon.svg";
import { addToCart, cartSelectors } from "../../features/cart";
import { toggleFavorite } from "../../features/favorites";
import { selectIsItemFavorite } from "../../features/favorites";
import { calcBonusPoints } from "../../features/bonuses";
import {isMobile} from "react-device-detect";
import VariationModal, { hasVariations } from "../VariationModal";

const stripHtml = (html) => { if (!html) return ''; return html.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').trim(); };

const ItemCard = (props) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const {
        main_image,
        name,
        short_description: description,
        average_rating: rate,
        rating_count: countFeedback,
        price: actualPrice,
        old_price: oldPrice,
        discount,
        id,
        item
    } = props;

    const image = item?.images?.[0]?.src || main_image;
    const vendorName = item?.store?.shop_name || item?.vendor;
    const vendorId = item?.store?.id;

    const minVariationPrice = (() => {
        const opts = item?.packaging_options;
        if (!Array.isArray(opts) || opts.length <= 1) return null;
        const prices = opts.map(o => Number(o.price)).filter(p => p > 0);
        if (prices.length === 0) return null;
        return Math.min(...prices);
    })();

    const { selectIsItemInCart } = cartSelectors;
    const isInCart = useSelector((state) => selectIsItemInCart(state, id));

    const isFavorite = useSelector((state) => selectIsItemFavorite(state, id));

    const [variationModalOpen, setVariationModalOpen] = useState(false);

    const handleNavigate = () => {
        navigate(`/product/${id}`);
    };

    const handleCartAction = (e) => {
        e.stopPropagation();
        if (hasVariations(item)) {
            setVariationModalOpen(true);
        } else if (isInCart) {
            navigate('/cart');
        } else {
            dispatch(addToCart(item, 1));
        }
    };

    const handleToggleFavorite = (e) => {
        e.stopPropagation();
        dispatch(toggleFavorite(item));
    };

    return (
        <>
            <div className={!isMobile ? 'icard' : 'icard-mobile'} role="link" tabIndex={0} onClick={handleNavigate} onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleNavigate() } }}>
                <button
                    className={`icard-favorite ${isFavorite ? 'active' : ''}`}
                    aria-label={isFavorite ? 'Убрать из избранного' : 'Добавить в избранное'}
                    onClick={handleToggleFavorite}
                >
                    <Heart />
                </button>

                <img src={image} alt={name} className="icard-img" loading="lazy"/>
                <div className="icard-name">{name}</div>

                {description && stripHtml(description) && (
                    <div className="icard-description">{stripHtml(description)}</div>
                )}

                {/*<div className="icard-rate-ctn">*/}
                {/*    <div className="icard-star-ctn">*/}
                {/*        <Star/>*/}
                {/*        <div className="icard-star-nmb">{rate}</div>*/}
                {/*    </div>*/}

                {/*</div>*/}

                <div className="icard-price-ctn">
                    <div className="icard-price-actual">
                        {minVariationPrice
                            ? <>от {Math.round(minVariationPrice).toLocaleString('ru-RU')}₽</>
                            : <>{actualPrice ? Math.round(actualPrice).toLocaleString('ru-RU') : 0}₽</>
                        }
                    </div>
                    {calcBonusPoints(minVariationPrice || actualPrice) > 0 && (
                        <div className="icard-bonuses">
                            <GiftFilled className="icard-bonuses-icon" />
                            +{calcBonusPoints(minVariationPrice || actualPrice).toLocaleString('ru-RU')} бонусов
                        </div>
                    )}
                    {!minVariationPrice && oldPrice && (
                        <div className="icard-price-discount-ctn">
                            <div className="icard-price-before">
                                {oldPrice ? Math.round(oldPrice).toLocaleString('ru-RU') : 0}₽
                            </div>
                            {discount && (
                                <div className="icard-discount">-{discount}%</div>
                            )}
                        </div>
                    )}
                </div>

                {/*{vendorName && (*/}
                {/*    <div className="icard-meta">*/}

                {/*    </div>*/}
                {/*)}*/}

                <div className="icard-footer">
                    <div
                        className={`icard-btn ${isInCart ? 'in-cart' : ''}`}
                        onClick={handleCartAction}
                    >
                        {isInCart ? (
                            <>
                                <CheckOutlined style={{ marginRight: "8px" }}/> В корзине
                            </>
                        ) : (
                            <>
                                <ShoppingCartOutlined style={{ marginRight: "8px", fontSize: "20px" }}/> В корзину
                            </>
                        )}
                    </div>
                </div>
            </div>

            <VariationModal
                open={variationModalOpen}
                onClose={() => setVariationModalOpen(false)}
                product={item}
            />
        </>
    )
}

export default memo(ItemCard);